var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-span-2"},[_c('div',{staticClass:"mt-6 flex items-center flex-wrap"},_vm._l((_vm.features),function(feature){return _c('calculator-selected-feature',{key:feature.key,attrs:{"text":feature.text}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }